/** Canonical storefront contact numbers (Egypt). */
export const STORE_MOBILE_TEL = '+201044777379';
export const STORE_MOBILE_DISPLAY = '+20 104 477 7379';
export const STORE_MOBILE_WA = '201044777379';

/** Short hotline — dial as-is (national short code). */
export const STORE_HOTLINE_TEL = '16105';
export const STORE_HOTLINE_DISPLAY = '16105';

export const STORE_WHATSAPP_HREF = `https://wa.me/${STORE_MOBILE_WA}`;
export const STORE_MOBILE_TEL_HREF = `tel:${STORE_MOBILE_TEL}`;
export const STORE_HOTLINE_TEL_HREF = `tel:${STORE_HOTLINE_TEL}`;
